function isPartOfColumn(start, end, cstart, cend) {
  return !(start >= cend || end <= cstart);
}

function getCellPosition(cell) {
  let end = 0;
  let pointer = cell;

  while (pointer && pointer.tagName !== 'TH') {
    end += pointer.colSpan;
    pointer = pointer.previousElementSibling;
  }

  return [end - cell.colSpan, end];
}

function findCellsInColumn(column, cells) {
  return cells.filter(cell => {
    const [start, end] = getCellPosition(cell);
    return isPartOfColumn(start, end, column.start, column.end);
  });
}

function filterCellsInRowsByColumn(column, rows, clone) {
  return rows.reduce((acc, row) => {
    const { rowName: name } = row.dataset;
    const cells = findCellsInColumn(
      column,
      Array.from(row.cells).filter(c => c.tagName === 'TD')
    );

    acc[name] = {
      name,
      node: row,
      cells: clone ? cells.map(cell => cell.cloneNode(true)) : cells,
    };

    return acc;
  }, {});
}

function iterateThroughColumnModes(modes, rows, clone) {
  return Object.values(modes).reduce((acc, mode) => {
    acc[mode.name] = {
      ...mode,
      rows: filterCellsInRowsByColumn(mode, Array.from(rows), clone),
    };

    return acc;
  }, {});
}

function splitRowsByColumns(columns, rows, clone = false) {
  return Object.values(columns).reduce((acc, column) => {
    acc[column.name] = {
      ...column,
      modes: iterateThroughColumnModes(column.modes, rows, clone),
    };
    return acc;
  }, {});
}

export default splitRowsByColumns;
